import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import InputNumber from 'antd/lib/input-number';
import Select from 'antd/lib/select';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';

import { PunctuationAlert } from '../../common/partials';
import rules from '../../../../common/rules/rules';
import accountRules from '../../../../common/rules/accountRules';
import { maritalStatusesT, onboardingSteps } from '../../../../common/enums';
import authApi from '../../../auth/api';
import Cookies from 'js-cookie';

const FormItem = Form.Item;

let doSubmit = false;

@translate()
@Form.create()
export default class StepForm2 extends Component {
  static propTypes = {
    accountData: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    saveAndGoToStep: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  handleSubmit = e => {
    if(e.preventDefault) e.preventDefault();
    doSubmit = false;

    const { form, saveAndGoToStep } = this.props;

    form.validateFields((err, formData) => {
      if (!err) {
        this.props.form.nextPage = "yes";
        this.handleSaveLoanCreationAttempt();
        saveAndGoToStep(onboardingSteps[2], formData);
      }
    });
  };

  handleEmptySpacesBlur = e => {
    e.target.value = e.target.value.split(" ").join("");
  }

  handleUpperCase = e => {
    e.target.value = e.target.value.toUpperCase()
  }

  handleUpperCaseFirst = e => {
    const words = e.target.value.split(' ');
    const firstWord = words.shift().toLowerCase();

    words.unshift(firstWord.charAt(0).toUpperCase() + firstWord.slice(1));
    e.target.value = words.join(' ');
}

  submitWasIssued() {
    doSubmit = true;
  }

  onBlurSaveLoanData = e => {
    this.handleSaveLoanCreationAttempt();
    if(doSubmit){
      this.handleSubmit(e);
    }
  }

  async handleSaveLoanCreationAttempt() {
    this.props.updateLoanCreationAttempt({ cookieId: Cookies.get('id'), form: this.props.form, step: 2 });
  }

  goBack = () => this.props.saveAndGoToStep(onboardingSteps[0], this.props.form.getFieldsValue());

  render() {
    const { accountData, form, t } = this.props;
    const { getFieldDecorator } = form;

    if (!accountData || !accountData.address) {
      return <Spin spinning={true} />;
    }

    return (
      <section className="onboarding-form">
        <h2 className="section-title">{t('Údaje o adrese')}</h2>
        <PunctuationAlert />
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <Row>
            <Col xs>
              <FormItem label={t('Ulica Vášho trvalého bydliska, číslo domu')}>
                {getFieldDecorator('address.street', {
                  rules: rules.required,
                  initialValue: accountData.address.street,
                })(
                  <Input
                    size="default"
                    placeholder={t('Ulica Vášho trvalého bydliska, číslo domu')}
                    autoFocus
                    onChange={this.handleUpperCaseFirst}
                    onBlur={this.onBlurSaveLoanData}
                  />
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem label={t('Mesto')}>
                {getFieldDecorator('address.city', {
                  rules: rules.required,
                  initialValue: accountData.address.city,
                })(<Input size="default" placeholder={t('Mesto')} 
                  onChange={this.handleUpperCaseFirst}
                  onBlur={this.onBlurSaveLoanData} />)}
              </FormItem>
            </Col>
            <Col xs={12} sm={6}>
              <FormItem label={t('PSČ')}>
                {getFieldDecorator('address.zip', {
                  rules: [...rules.required, ...accountRules.zip],
                  initialValue: accountData.address.zip,
                })(<Input size="default" placeholder={t('PSČ')} 
                  onChange={this.handleEmptySpacesBlur}
                  onBlur={this.onBlurSaveLoanData} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem label={t('Počet rokov bývania na adrese')}>
                {getFieldDecorator('yearsAtAddress', {
                  initialValue: accountData.yearsAtAddress,
                  rules: [
                    { required: true, message: t('Povinné pole') },
                    { type: 'number', max: 99, message: t('Maximálne 99') },
                  ],
                })(
                  <InputNumber
                    size="default"
                    min={0}
                    max={99}
                    precision={0}
                    style={{ width: '100%' }}
                    onBlur={() => this.onBlurSaveLoanData()}
                  />
                )}
              </FormItem>
            </Col>
            <Col xs={12} sm={6}>
              <FormItem label={t('Číslo Vášho občianskeho preukazu')}>
                {getFieldDecorator('idCardNumber', {
                  rules: accountRules.idCardNumber,
                  initialValue: accountData.idCardNumber,
                })(<Input size="default" placeholder={t('Číslo Vášho občianskeho preukazu')}
                  onChange={this.handleUpperCase}
                  onBlur={this.onBlurSaveLoanData}  />)}
              </FormItem>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs>
              <h2 className="section-title">{t('Údaje o rodine')}</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem label={t('Rodinný stav')}>
                {getFieldDecorator('maritalStatus', {
                  initialValue: accountData.maritalStatus,
                  rules: rules.required,
                })(
                  <Select size="default" placeholder={t('Rodinný stav')} onBlur={this.onBlurSaveLoanData}>
                    {Object.entries(maritalStatusesT).map(([key, value]) => (
                      <Select.Option value={key} key={key}>
                        {value}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col xs={12} sm={6}>
              <FormItem label={t('Počet detí')} className="select-kids">
                {getFieldDecorator('kids', { initialValue: accountData.kids })(
                  <InputNumber size="default" placeholder={t('Počet detí')} min={0} onBlur={this.onBlurSaveLoanData}/>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row center="xs" className="form-actions-row">
            <Col xs={12} sm={6} className="form-actions-col">
              <a onClick={this.goBack}>{t('Späť')}</a>
              <Button type="primary" size="large" htmlType="submit" className="btn-block" onMouseDown={this.submitWasIssued}>
                {t('Pokračovať')}
              </Button>
            </Col>
          </Row>
        </Form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/StepForm2.js